import { Cell, CellWithHierarchy } from '@pelckmans/elementis/components/table';
import { ComponentProps, useContext } from 'react';
import { getResultPercentages, getStatusForScorableItem } from '../../../../../utils/results';
import { HorizontalScrollContext } from '../../context/HorizontalScrollContextProvider';
import { TableDataRow } from '../types';

export const TableRow = ({ row }: { row: TableDataRow }) => {
  const { horizontalScroll } = useContext(HorizontalScrollContext);

  return (
    <tr>
      <CellWithHierarchy
        hierarchyProps={{
          level: row.level as ComponentProps<typeof CellWithHierarchy>['hierarchyProps']['level'],
        }}
        sticky={horizontalScroll}
      >
        <Cell.Text title={row.title} subTitleBot={row.subTitle!} startAdornment={row.icon} />
      </CellWithHierarchy>
      {row.columns.map((column, i) => {
        if (column && 'Cell' in column) {
          return column.Cell();
        }

        const status = column && getStatusForScorableItem(column);

        return column ? (
          <Cell key={`${column.exerciseId}-${column.isAssignment}`}>
            <Cell.Results
              {...getResultPercentages(column.score, column.needsGrading)}
              quantifiable
              status={status}
              showTooltip
              variant="full"
            />
          </Cell>
        ) : (
          <Cell key={i} />
        );
      })}
    </tr>
  );
};
